import React, { useState } from "react";
import Client1 from "../assets/images/1.jpg";
import Client2 from "../assets/images/2.jpg";
import Client3 from "../assets/images/3.jpg";
import Client4 from "../assets/images/4.jpg";
import Client5 from "../assets/images/5.jpg";
import Client6 from "../assets/images/6.jpg";
import Slider from "react-slick";
import Carousel, { Modal, ModalGateway } from "react-images";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function CustomCarousel() {
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);
  var settings = {
    dots: false,
    autoplay: true,
    autoplaySpeed: 1000,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2,
          arrows: false,
          // prevArrow: false,
          // nextArrow: false,
        },
      },
      {
        breakpoint: 720,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: false,
          // prevArrow: false,
          // nextArrow: false,
        },
      },
    ],
  };
  const openLightbox = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };
  const images = [
    { src: "/assets/images/1.jpg" },
    { src: "/assets/images/2.jpg" },
    { src: "/assets/images/3.jpg" },
    { src: "/assets/images/4.jpg" },
    { src: "/assets/images/5.jpg" },
    { src: "/assets/images/6.jpg" },
  ];
  return (
    <div className="Carousel">
      <Slider {...settings}>
        {images.map((item, i) => (
          <div
            className="carouselItem"
            onClick={(e) => {
              e.stopPropagation();
              openLightbox(i);
            }}
          >
            <img src={item.src} alt="click here" />
          </div>
        ))}
      </Slider>
      <ModalGateway>
        {viewerIsOpen ? (
          <Modal onClose={closeLightbox}>
            <Carousel
              currentIndex={currentImage}
              views={images.map((x) => ({
                ...x,
                srcset: x.srcSet,
                caption: x.title,
              }))}
            />
          </Modal>
        ) : null}
      </ModalGateway>
    </div>
  );
}

export default CustomCarousel;
